/**
 * Single source of truth for portal role names on the frontend. Mirrors the
 * backend role model exactly — do NOT hand-copy role lists elsewhere; import
 * from here instead.
 */
export const INTERNAL_ROLES = ["SUPERADMIN", "ADMIN", "SALES_DIRECTOR", "SALES", "OTKUP", "KVALITET", "KVALITET_LEAD", "MARKETING", "PORTIR"] as const;
export const CUSTOMER_ROLES = ["CUST_PROCUREMENT", "CUST_MANAGER"] as const;
export const SUPPLIER_ROLES = ["SUPP_MANAGER"] as const;
export const ALL_ROLES = [...INTERNAL_ROLES, ...CUSTOMER_ROLES, ...SUPPLIER_ROLES] as const;
export type RoleName = typeof ALL_ROLES[number];

/**
 * Internal roles offerable through the invite form. Excludes SUPERADMIN — the
 * root account is bootstrapped out-of-band, never handed out via an invite.
 */
export const INVITABLE_INTERNAL_ROLES = INTERNAL_ROLES.filter((r) => r !== "SUPERADMIN");
